export function customTabs() {
    (function() {
        var KEY = { LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40, HOME: 36, END: 35 };

        function groupOf($el) { 
            return $el.closest('[data-group]').data('group'); 
        }
        function tabsIn(group) { 
            return $('[role="tablist"][data-group="' + group + '"] [role="tab"]'); 
        }

        function activate($tab, setFocus) {
            var group = groupOf($tab);

            tabsIn(group).attr({ 'aria-selected': 'false', tabindex: '-1' });
            $tab.attr({ 'aria-selected': 'true', tabindex: '0' });

            $('.panels[data-group="' + group + '"] [role="tabpanel"]').prop('hidden', true);
            $('#' + $tab.attr('aria-controls')).prop('hidden', false);

            if (setFocus) { $tab.trigger('focus'); }
        }

        // Pointer + Enter-on-anchor
        $(document).on('click', '[role="tab"]', function (e) {
            e.preventDefault();
            activate($(this), false);
        });

        // Keyboard navigation within the tablist
        $(document).on('keydown', '[role="tab"]', function (e) {
            var $tab = $(this);
            var vertical = $tab.closest('[role="tablist"]').attr('aria-orientation') === 'vertical';
            var $tabs = tabsIn(groupOf($tab));
            var i = $tabs.index($tab);
            var prev = vertical ? KEY.UP : KEY.LEFT;
            var next = vertical ? KEY.DOWN : KEY.RIGHT;
            var $target;

            if (e.which === prev)      { $target = i > 0 ? $tabs.eq(i - 1) : $tabs.last(); }
            else if (e.which === next) { $target = i < $tabs.length - 1 ? $tabs.eq(i + 1) : $tabs.first(); }
            else if (e.which === KEY.HOME) { $target = $tabs.first(); }
            else if (e.which === KEY.END)  { $target = $tabs.last(); }
            else { return; }

            e.preventDefault();
            activate($target, true); // selection follows focus
        });

        // Init each group from its pre-selected tab (or the first), syncing state + hidden
        $('[role="tablist"]').each(function () {
            var $tabs = tabsIn($(this).data('group'));
            var $sel = $tabs.filter('[aria-selected="true"]').first();
            activate($sel.length ? $sel : $tabs.first(), false);
        });
    })();
}